import { addMinutes, isDate, parseISO } from "date-fns";

export const fromUTC = (date) => {
    if (!date) {
        return;
    }

    const now = new Date(date);
    const offset = now.getTimezoneOffset();
    return addMinutes(isDate(date) ? date : parseISO(date), -offset);
};

export const toUTC = (date) => {
    if (!date) {
        return;
    }
    const now = new Date(date);
    const offset = now.getTimezoneOffset();
    return addMinutes(isDate(date) ? date : parseISO(date), offset);
};

export const isValidGuid = (guid) => {
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return guidRegex.test(guid);
};
